import { useMemo } from 'react'

import { EncashmentsRowItemType, EncashmentsStatusType } from 'app/dataTypes/reports/data'


export function useEncashmentsStatusAll(rows: Array<EncashmentsRowItemType>) {
  const res = useMemo(() => {
    const statusesAll = {
      hasItemsToRecord: false,
      hasItemsToCancel: false,
    }
    rows.forEach(({ encashmentsSummary }) => {
      if (encashmentsSummary.status === EncashmentsStatusType.WaitingForCash) {
        statusesAll.hasItemsToCancel = true
      }
      if (encashmentsSummary.status === EncashmentsStatusType.WaitingForCash) {
        statusesAll.hasItemsToRecord = true
      }
    })
    return statusesAll
  }, [rows])
  return res
}
